<template>
    <div class="text-xs-center">
        <v-bottom-sheet v-model="showInfo">
            <v-footer dark padless>
                <v-card class="flex" flat tile>
                    <v-card-title class="primary">
                        <strong class="subheading">SDeveloper</strong>

                        <v-spacer></v-spacer>

                        <v-btn class="mx-4" dark icon href="https://www.linkedin.com/company/sdeveloper" target="_blank">
                            <v-icon size="24px">fab fa-linkedin</v-icon>
                        </v-btn>

                        <v-btn class="mx-4" dark icon href="https://wa.me/5535991131366" target="_blank">
                            <v-icon left> fab fa-whatsapp </v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="primary">
                        <div>Rua Tranquilo Luis Rosa, 130 - CASA 1</div>
                        <div>Atibaia-SP</div>
                        <div><v-icon size="20px" left>call</v-icon>+55 (35) 9 9113-1366</div>
                        <div><v-icon size="20px" left>email</v-icon>anderson@sdeveloper.io</div>
                    </v-card-text>
                    <v-card-text class="py-2 white--text text-center">
                        <v-btn text href="https://sdeveloper.io" target="_blank">
                            &copy;{{ new Date().getFullYear() }} —
                            <strong>sdeveloper.io</strong>
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-footer>
        </v-bottom-sheet>
    </div>
</template>

<script>
export default {
    name: "Info",
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        showInfo: {
            get: function () {
                return this.show;
            },
            set: function (value) {
                if (!value) {
                    this.$emit("onClose");
                }
            },
        },
    },
};
</script>